import { pad } from 'crypto-js';

export const blogPostStepper = {
  stepOneDesc: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    color: 'var(--color-text-secondary)'
  },
  stepOneContainer: {
    mt: 3,
    maxWidth: '50%'
  },
  urlInputBox: {
    mt: 2
  },
  urlInputLabel: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    mb: 1,
    color: 'var(--color-text-dark)'
  },
  urlInputField: {
    gap: '8px',
    borderRadius: '8px',
    border: '1px ',
    opacity: '0px'
  },
  descField: {
    gap: '8px',
    borderRadius: '8px',
    border: '1px',
    opacity: '0px'
  },
  businessDescMessage: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-tertiary)',
    mt: 1
  },
  inputAdornment: {
    marginTop: 'auto',
    mb: 1
  },
  inputAdornmentText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'right'
  },
  nextBtn: {
    padding: '10px 18px 10px 18px',
    borderRadius: '8px',
    opacity: '0px',
    mt: 3
  },
  info: {
    mt: 2,
    display: 'flex',
    alignItems: 'flex-start',
    padding: '12px',
    gap: '12px',
    borderRadius: '8px',
    opacity: '0px',
    border: '1px solid var(--color-secondary)',
    backgroundColor: 'var(--color-success-bg-ultra)'
  },
  infoIcon: {
    width: '24px',
    height: '24px',
    gap: '0px',
    border: '2px',
    opacity: '0px',
    color: 'var(--color-secondary)'
  },
  infoText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'rgba(31, 37, 42, 1)'
  },
  addCompetitor: {
    width: 'max-content',
    height: 'Fixed (35px)',
    padding: '6px 12px 6px 12px',
    borderRadius: '5px',
    gap: '4px',
    color: 'var(--color-primary)'
  },
  addOutlinedIcon: {
    width: '20px',
    height: '20px',
    color: 'var(--color-purple-deep-alt)'
  },
  addCompetitorText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-purple-deep-alt)',
    marginLeft: '-5px'
  },
  btnContainer: {
    display: 'flex'
  },
  drawerBox: {
    width: { xs: 350, sm: 650 },
    padding: 4
  },
  stepper: {
    marginLeft: '-6px',
    marginTop: '2rem',
    '& .MuiStepConnector-root': {
      paddingLeft: '25px',
      paddingRight: '25px'
    },
    '& .MuiStepConnector-line': {
      borderColor: 'var(--color-primary) !important',
      borderTopWidth: '1px'
    }
  },
  inputCommon: {
    backgroundColor: 'white',
    border: '1px solid black',
    borderRadius: '8px'
  },
  competitorMainBox: {
    display: 'flex',
    gap: '8px',
    marginTop: '8px'
  },
  competitorUrlBox: {
    borderRadius: '6px',
    padding: '12px'
  },
  competitorLabel: {
    fontFamily: 'Inter',
    fontSize: '13px',
    fontWeight: 500,
    lineHeight: 'var(--line-height-18)',
    textAlign: 'left',
    color: 'var(--color-primary)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  competitorTitle: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-18)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  competitorTitleBox: {
    display: 'flex',
    gap: '6px',
    alignItems: 'center'
  },
  avatarSx: {
    width: '15px',
    height: '15px'
  },
  leavePageMainBox: {
    textAlign: 'center',
    padding: '0px 16px 32px 16px'
  },
  leavePageBtnBox: {
    display: 'flex',
    gap: '8px',
    marginTop: '24px'
  },
  leavePageTitleSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-20)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-30)',
    color: 'var(--color-primary)',
    marginBottom: '24px'
  },
  leavePageDescSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: 400,
    maxWidth: '330px',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  leavePageBtnSx: {
    padding: '10px 18px 10px 18px',
    gap: '6px',
    borderRadius: '6px'
  },
  gscPageMainPageSx: {
    textAlign: 'center',
    marginTop: '32px'
  },
  gscPageTitleSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-18)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-28)',
    textAlign: 'center',
    color: 'var(--color-text-muted)',
    marginBottom: '8px'
  },
  gscPageDescSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-18)',
    textAlign: 'center',
    color: 'var(--color-text-tertiary)',
    marginBottom: '16px',
    maxWidth: '550px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  gscPageLink: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)',
    cursor: 'pointer'
  },
  linkBox: {
    marginBottom: '32px',
    display: 'flex',
    justifyContent: 'center'
  },
  imgBox: {
    display: 'flex',
    justifyContent: 'center'
  },
  gscBtn: {
    padding: '12px 18px 12px 18px',
    gap: '8px',
    borderRadius: '6px',
    maxWidth: '500px',
    marginTop: '32px'
  },
  checkIconImg: {
    width: '100px',
    height: '25px',
    display: 'flex',
    alignSelf: 'start',
    marginTop: '2px',
    backgroundSize: 'cover'
  },
  snackBarTitle: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: 600,
    lineHeight: '27px',
    color: 'var(--color-primary)'
  },
  snackBarDesc: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-dark)'
  },
  urlSx: {
    color: 'var(--color-primary)'
  },
  watchTutorial: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    cursor: 'pointer'
  },
  snackBarAlert: {
    width: '100%', // Ensure the Alert stretches to its container or specify a max-width
    maxWidth: '610px', // Example of setting a max width, adjust based on your layout needs
    backgroundColor: 'rgba(235, 251, 233, 1)', // Set the background color to red
    color: 'rgba(65, 66, 71, 1)', // Set the text color to white
    '.MuiAlert-message': {
      color: 'var(--color-primary)',
      fontFamily: 'Inter',
      fontSize: 'var(--font-size-14)',
      fontWeight: 400,
      lineHeight: 'var(--line-height-20)',
      textAlign: 'left'
      // wordBreak: 'break-all', // Ensures that words can be broken at any point, improving break behavior
      // whiteSpace: 'pre-wrap' // Allows text to wrap and respects newline characters in the alert message
    },
    '.MuiAlert-icon': {
      color: 'var(--color-secondary)' // Set the alert icon color to white
    },
    border: '1px solid rgba(135, 220, 184, 1)'
  },
  watchTutorialText: {
    fontSize: 'var(--font-size-14)',
    fontWeight: 600
  },
  tableCellText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-22)',
    textAlign: 'left',
    color: 'var(--color-text-near-black)',
    padding: '1.5rem !important'
  },
  keywordCell: {
    minWidth: 150,
    // textDecoration: 'underline', // Add underline on hover
    '&:hover': {
      // cursor: 'pointer'
    }
  },
  tableCellTitle: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-primary)',
    '&:hover': {
      color: 'var(--color-purple-deep-alt)'
    }
  },
  metaDescription: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-secondary)',
    '&:hover': {
      color: 'var(--color-primary)'
    }
  },
  secondaryKeyword: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  startOverBtnText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-20)'
  }
};

export const drawerDataCss = {
  blogPostTitleIdea: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: 'var(--line-height-18)',
    textAlign: 'left',
    color: 'var(--color-text-tertiary)'
  },
  trends: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-20)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-30)',
    textAlign: 'left',
    color: 'rgba(16, 24, 40, 1)'
  },
  headerBox: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  mainCardsBox: {
    display: { xs: 'grid', sm: 'flex' },
    justifyContent: 'space-between',
    gap: 2,
    mt: 2
  },
  subBoxes: {
    width: '100%',
    padding: '20px',
    gap: '32px',
    borderRadius: '4px',
    border: '1px solid var(--color-border)',
    opacity: '0px'
  },
  subBoxHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  helpIcon: {
    width: '20px',
    height: '20px',
    color: 'var(--color-text-tertiary)'
  },
  subHeaderFont: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-30)',
    textAlign: 'left'
  }
};

export const upgradeModalBlogPostSx = {
  headBoxSx: {
    display: 'flex',
    gap: '8px',
    marginBottom: '12px',
    justifyContent: 'center'
  },
  mainBox: {
    textAlign: 'center',
    padding: '0px 0px 27px 0px',
    maxWidth: '28rem'
  },
  upgradeModalTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-20)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-30)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  descSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'center',
    color: 'var(--color-text-mid)',
    marginBottom: '24px'
  },
  btnSx: {
    backgroundColor: 'var(--color-secondary)',
    '&:hover': {
      backgroundColor: 'var(--color-secondary)'
    },
    maxWidth: '25rem'
  },
  btnTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'center',
    color: 'var(--color-primary)',
    minWidth: '155px'
  },
  cancelIconBoxSx: {
    width: '100%',
    display: 'flex',
    justifyContent: 'end',
    marginTop: '-15px'
  }
};

export const generateIdeasLoaderSx = {
  mainBox: {
    textAlign: 'center',
    padding: '0px 24px 64px 24px'
  },
  desc: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-20)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-30)',
    textAlign: 'center',
    color: 'var(--color-primary)',
    marginTop: '-28px'
  },
  spinner: {
    margin: 'auto',
    marginTop: '-28px'
  }
};

export const createBriefSx = {
  titleSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-18)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-38)',
    textAlign: 'center',
    color: 'var(--color-primary)'
  },
  btnBoxSx: {
    display: 'flex',
    gap: '8px'
  }
};

export const previousBlogSearchesSx = {
  rowSx: {
    cursor: 'pointer'
  },
  rowDescText: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-18)',
    color: 'var(--color-primary)',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 3, // Limits text to 3 lines
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },

  rowDescCell: {
    maxWidth: '400px'
  },
  rowCompetitorText: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-14)',
    color: 'var(--color-text-near-black)'
  },
  rowCompetitorBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexWrap: 'wrap'
  },
  rowCompetitorAvatarBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  }
};
